import PropertyPanel from 'app/shared/model/PropertyPanel';

import adproductsUtils from 'app/shared/utils/adproductsUtils';

const shouldHideBoostColumn = (hasBoost, productTypes) => !hasBoost
    || (productTypes.length === 0)
    || adproductsUtils.hasPackage(productTypes)
    || adproductsUtils.hasReit(productTypes)
    || adproductsUtils.hasRocketship(productTypes);

const Property = ({
    aliasEncoded = 0,
    listingAlias = 0,
    feedId = '',
    feedName = '',
    isFeed = '',
    active = false,
    address = {},
    isMultifamily = false,
    name = '',
    panels = [],
    photoUrl = '',
    status = {},
    productTypes = [],
    hasBoost = false,
    isConnectedExperience = false,
    vrModelCount = 0,
    additionalListingSources = [],
    syndicationOverviewDisplayStatus = '',
    activityMessage = '',
} = {}) => ({
    aliasEncoded: String(aliasEncoded),
    listingAlias: String(listingAlias),
    feedId: String(feedId),
    feedName: String(feedName),
    isFeed: Boolean(isFeed),
    active: Boolean(active),
    address: Object(address),
    isMultifamily: Boolean(isMultifamily),
    name: String(name),
    panels: panels.map(item => PropertyPanel(item)),
    photoUrl: String(photoUrl),
    status: Object(status),
    productTypes: adproductsUtils.mapProductTypes(productTypes),
    hasBoost: Boolean(hasBoost),
    isConnectedExperience: Boolean(isConnectedExperience),
    hideBoostColumn: Boolean(shouldHideBoostColumn(hasBoost, productTypes)),
    vrModelCount: Number(vrModelCount),
    additionalListingSources,
    syndicationOverviewDisplayStatus: String(syndicationOverviewDisplayStatus),
    activityMessage: String(activityMessage),
});

export default Property;
